import axiosInstance from "./axiosInstance";

export const getAllVessels = async () => {
  const res = await axiosInstance.get(`/vessels/list`);
  return res.data;
};

export const getVesselDetails = async (vesselId) => {
  const res = await axiosInstance.get(`/admin/vessels/details/${vesselId}`);
  return res.data;
};

export const getVesselPerformanceMetaData = async (vesselId, startDate, endDate, bdn, voyageId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/metadata?start=${startDate}&end=${endDate}&bdn=${bdn}&voyageId=${voyageId}`);
  return res.data.data;
}

export const getVesselPerformanceFuelConsumption = async (vesselId, startDate, endDate, bdn, voyageId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/fuel-consumption?start=${startDate}&end=${endDate}&bdn=${bdn}&voyageId=${voyageId}`);
  return res.data.data;
}

export const getVesselPerformanceFuelRemaining = async (vesselId, startDate, endDate, bdn, voyageId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/fuel-remaining?start=${startDate}&end=${endDate}&bdn=${bdn}&voyageId=${voyageId}`);
  return res.data.data;
}

export const getVesselPerformanceMainEnginePower = async (vesselId, startDate, endDate, bdn, voyageId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/main-engine-power?start=${startDate}&end=${endDate}&bdn=${bdn}&voyageId=${voyageId}`);
  return res.data.data;
}

export const getVesselPerformanceSfocEfficiency = async (vesselId, startDate, endDate, bdn, voyageId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/sfoc-efficiency?start=${startDate}&end=${endDate}&bdn=${bdn}&voyageId=${voyageId}`);
  return res.data.data;
}

export const getVesselPerformanceBdnId = async (vesselId) => {
  const res = await axiosInstance.get(`/vessels/${vesselId}/performance/bdnid`);
  return res.data.data;
}

export const getVesselPerformanceDetails = async (vesselId) => {
  const res = await axiosInstance.get(`/admin/vessels/performance/${vesselId}`);
  return res.data;
};

export const getVesselListDetails = async (vesselId) => {
  const res = await axiosInstance.get(`/vessels/list/${vesselId}`);
  return res.data;
};

export const createVessel = async (data) => {
  const res = await axiosInstance.post(`/admin/vessels/create/`, data)
  return res.data;
};

export const updateVessel = async (id, data) => {
  const res = await axiosInstance.put(`/admin/vessels/update/${id}`, data);
  return res.data;
};

export const deleteVessel = async (id) => {
  const res = await axiosInstance.delete(`/admin/vessels/delete/${id}`);
  return res.data;
};

export const fetchVesselRawData = async (vesselId, voyageId = null, filters = { startDate: null, endDate: null }) => {
  const queryParams = new URLSearchParams();

  if (voyageId) {
    queryParams.append("voyageId", voyageId);
  } else {
    if (filters?.startDate) queryParams.append("startDate", filters.startDate);
    if (filters?.endDate) queryParams.append("endDate", filters.endDate);
  }

  return await axiosInstance.get(`/vessels/${vesselId}/dataquality`, {
    params: queryParams,
  });
};

export const getVesselVoyages = async (vesselId) => {
  return await axiosInstance.get(`/admin/vessels/voyage/list/${vesselId}`);
};

// updated
export const getVesselVoyagesByVoyageId = async (vesselId) => {
  return await axiosInstance.get(`/admin/vessels/voyage/listt/${vesselId}`);
};
export const getVesselVoyagesByVesselId = async (vesselId) => {
  return await axiosInstance.get(`/admin/vessels/voyage/listbyvesselid/${vesselId}`);
};

export const updateVesselVoyageById = async (voyageId, payload) => {
  return await axiosInstance.put(
    `/admin/vessels/voyage/update/${voyageId}`,
    payload
  );
};